import script from "./Page2.vue?vue&type=script&setup=true&lang=js"
export * from "./Page2.vue?vue&type=script&setup=true&lang=js"

import "./Page2.vue?vue&type=style&index=0&id=4d509857&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d509857"]])

export default __exports__